import React from 'react'
import { Skeleton, Flex, Stack, Container } from '@chakra-ui/react'
import { BLOG_HEIGHT, BLOG_LIMIT } from '@constants/blog.constant'
import { useResponsive } from '@common/hooks'

const SkeletonListBlog = () => {
  const { lgMax } = useResponsive()

  const displaySkelotons = () => {
    const arr = Array.from({ length: BLOG_LIMIT }, (v, k) => k)
    return arr.map((v) => {
      return (
        <Flex
          gap={1}
          key={v}
          flexDirection={lgMax ? 'column' : 'row'}
          w={'100%'}
        >
          <Flex flex={1}>
            <Skeleton
              key={v}
              startColor={'bgSkeleton'}
              endColor={'bgSkeleton'}
              h={BLOG_HEIGHT}
              flex={1}
            />
          </Flex>
          <Flex flex={1}>
            <Skeleton
              key={v}
              startColor={'bgSkeleton'}
              endColor={'bgSkeleton'}
              h={BLOG_HEIGHT}
              flex={1}
            />
          </Flex>
        </Flex>
      )
    })
  }
  return (
    <Container w={'100%'}>
      <Flex justify={'center'} mt={10} w="100%">
        <Stack spacing={10} w={'100%'}>
          {displaySkelotons()}
        </Stack>
      </Flex>
    </Container>
  )
}

export default SkeletonListBlog
